'use strict';

var client = require('@apollo/client');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function parseFormSubmissionErrors(maybeError) {
    let formErrors = null;
    try {
        const error = maybeError instanceof Error ? maybeError : null;
        if (!error) return null;
        if (client.isApolloError(error)) {
            const { graphQLErrors = [] } = error;
            formErrors = graphQLErrors.reduce((results, item)=>{
                const { message } = item;
                try {
                    const parsedMessage = JSON.parse(message);
                    return _extends({}, results, parsedMessage);
                } catch (e) {
                    return _extends({}, results, {
                        error: [
                            message
                        ]
                    });
                }
            }, {});
        } else {
            console.warn('Caught Error', (error == null ? void 0 : error.message) || maybeError);
            formErrors = {
                error: [
                    'An error occurred.'
                ]
            };
        }
    } catch (error) {
        console.error(error);
    }
    return formErrors;
}

module.exports = parseFormSubmissionErrors;
